<br><br>
<div class="container">
    <div class="row">
        <div class="col text-center">
            <h3>You successfully reset your account's password.</h3>

		<a class="btn btn-secondary text-white" 
        style="border-radius:0;border:none;background-color:#1cd5db;margin-right:2%"
		[routerLink]="['']" 
		routerLinkActive="active">
		<i class="fas fa-home"></i> Go to home page</a>

        <a class="btn btn-secondary text-white" 
        style="border-radius:0;border:none;background-color:#1cd5db"
		[routerLink]="['/login']" 
		routerLinkActive="active">
		<i class="fas fa-sign-in-alt"></i> Login</a>
        </div>
    </div>
</div>
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br /><br />
<br /><br />
<br />
<br />
<br />
<br /><br />
<br /><br />
<br />
<br />
<br />
